
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Phone = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 19 19" {...props} className={ modClassName }>
      <g>
        <g transform="translate(-312.000000, -907.000000)">
          <g transform="translate(309.000000, 904.000000)">
            <path d="M13.7332361,7.90502598 L13.6819135,8.04238508 C13.489298,8.64339289 13.6818308,9.31109891 14.1806027,9.71372174 L15.723,10.976 L15.6709916,11.0768212 C14.6184042,13.0028244 13.0151804,14.6107114 11.0828678,15.6665421 L10.979,15.72 L9.71382697,14.1733435 C9.27659872,13.6396681 8.54131193,13.4586459 7.90833666,13.7299208 L4.18966231,15.3236371 C3.49940156,15.6268024 3.12201023,16.3702059 3.28936507,17.0975552 L4.08633272,20.5510797 C4.24852164,21.251736 4.87135209,21.75 5.59406341,21.75 C14.5159127,21.75 21.75,14.520225 21.75,5.59407539 C21.75,4.87282768 21.253009,4.24733755 20.5500992,4.08611984 L17.0980242,3.28948707 C16.3703043,3.12204708 15.6250382,3.49944496 15.3283036,4.18322416 L13.7332361,7.90502598 Z M16.7612076,4.75118279 L20.2137899,5.5479321 C20.2353789,5.55288438 20.25,5.57128581 20.25,5.59407539 C20.25,13.6915976 13.6876858,20.25 5.59406341,20.25 C5.57137973,20.25 5.55287468,20.235196 5.54780526,20.2132961 L4.75106067,16.7607381 C4.74598786,16.7386902 4.75978957,16.711503 4.78672517,16.6996714 L8.49921522,15.1086385 C8.51733267,15.1008739 8.53896189,15.1061988 8.55328829,15.1236854 L10.1999036,17.1354761 C10.4174156,17.4012264 10.7876349,17.4852952 11.098589,17.3395479 C13.8368624,16.0560926 16.0634311,13.8211795 17.3426946,11.0956395 C17.4886715,10.7846279 17.4046587,10.4141974 17.1387925,10.1965909 L15.1267241,8.54975071 C15.1097549,8.5360306 15.1042916,8.51378299 15.1119534,8.49590532 L16.705671,4.77723386 C16.713526,4.75915282 16.7392442,4.74612926 16.7612076,4.75118279 Z"></path>
          </g>
        </g>
      </g>
    </IconBase>);
};

Phone.defaultProps = {
  title: 'Phone',
};

export default Phone;
